module.exports = __webpack_public_path__ + "media/images/top/qa/human-1-21754b62153d9215f11da2434592960a.png";